import styled from 'styled-components';

export const TextError = styled.div`
  margin-left: ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colors.redCrayola};
`;

export const TextWarning = styled.div`
  margin-left: ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colorsInObjects.yellow[500]};
`;

export const ErrorContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
  display: flex;
  align-items: center;
`;
